import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import { toaster } from '@/shared/ui'
import type { AxiosError } from 'axios'
import { HTTP_MESSAGES } from '@/shared'

// Only retry on network errors or 5xx — never on 4xx (they won't succeed on retry)
function shouldRetry(failureCount: number, error: unknown): boolean {
  const status = (error as AxiosError).response?.status
  if (status && status >= 400 && status < 500) return false
  return failureCount < 1
}

function handleGlobalError(error: unknown): void {
  const axiosError = error as AxiosError
  const config = axiosError.config as any

  // Requests that opted out handle their own error toasts (e.g. login)

  const status = axiosError.response?.status

  // 401/403 are handled by the axios interceptor (toast + redirect) — skip here
  if (status === 401 || status === 403) return

  if (status === 400) {
    console.log('AXIOS ERROR:', axiosError.status)
    // const message = axiosError.response?.data
    // if (message) toaster.error({ title: message })

    return
  }

  if (config?._skipGlobalErrorHandler && status !== 500) return

  toaster.error({ title: HTTP_MESSAGES(status ?? 500) })
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => handleGlobalError(error),
  }),
  mutationCache: new MutationCache({
    onError: (error) => handleGlobalError(error),
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: shouldRetry,
    },
    mutations: {
      retry: shouldRetry,
    },
  },
})
